import { useContext } from 'react'
import { Helmet } from 'react-helmet-async'

import { faGlobe } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Columns, DashboardModule, LoadingModule,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import { generateUrls } from '@hooks/useStatus'
import useStatuses from '@hooks/useStatuses'

import ListBlankState from '@components/ListBlankState'
import PageFilterModule from '@components/PageFilterModule'
import PageHeader from '@components/PageHeader'

import StatusListItem from '../StatusListItem'

const buildPageFilterFields = () => {
  const style = { marginBottom: 16 }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Filter by Title or ID',
    },
  ]
}

interface PageContentProps {
  pageFilters: {
    [key: string]: any,
  },
}

const PageContent = (props: PageContentProps) => {
  const { pageFilters } = props

  const statusesPayload = useStatuses({
    filters: pageFilters,
    performHttpRequests: true,
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredStatuses,
    filteredStatusesCount,
    hasFilteredStatuses,
    loading,
  } = statusesPayload

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      resetFilters,
      updateFilters,
    },
    defaultFilters,
  } = pageContext

  const { statusesIndexUrl } = generateUrls()

  return (
    <>
      <Helmet>
        <title>Statuses | Realhub</title>
      </Helmet>

      <PageHeader
        activeTabBarItemKey="statuses"
        tabBarItems={[
          {
            href: statusesIndexUrl,
            icon: faGlobe,
            key: 'statuses',
            title: 'Statuses',
          },
        ]}
        title="Statuses"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <LoadingModule loading={loading} times={3} />

            {!loading && !hasFilteredStatuses && <ListBlankState />}

            {!loading && hasFilteredStatuses && (
              <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title="Statuses">
                <Box flexDirection="column">
                  {filteredStatuses.map(status => (
                    <StatusListItem key={status.id} status={status} />
                  ))}
                </Box>

                <DashboardModule.LoadMoreFooter
                  callbacks={{ loadMore }}
                  canLoadMore={canLoadMore}
                  entityCount={filteredStatusesCount}
                  loading={loading}
                />
              </DashboardModule>
            )}
          </Columns.Main>

          <Columns.Sidebar>
            <PageFilterModule
              callbacks={{ resetFilters, updateFilters }}
              defaultFilters={defaultFilters}
              // @ts-expect-error TS2322
              filterFields={buildPageFilterFields()}
              pageFilters={pageFilters}
              title="Filters"
            />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
